<template>
    <div class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-right">
                <div class="search-name">汽配数据上传的Excel模板</div>
                <el-button type="text" class="search-btn" @click="downFile()">点击下载</el-button>
                <el-upload
                    :action="url"
                    :on-error="uploadErr"
                    :headers="headerObj"
                    accept=".xls,.xlsx"
                    :show-file-list="false"
                    :before-upload="beforeUpload"
                    :on-success="uploadSuccess"
                    :readonly="saveLoading || loading"
                    v-loading.fullscreen.lock="loading"
                >
                    <el-button size="small" icon="fa fa-file-excel-o" class="search-btn btn-primary"> 选择文件</el-button>
                </el-upload>
                <el-button size="small" icon="el-icon-upload" class="search-btn btn-primary" @click="handleExport" :readonly="saveLoading"
                    >保存数据<span v-if="tableData.length">（{{ tableData.length }}）</span></el-button
                >
                <div class="explain">
                    （* 导入的数据中会判断是否存在相同商品({{
                        isCheckCode ? '编码相同' : '设定的唯一性条件'
                    }})，如果不存在新增数据，存在则根据导入条件编辑数据。操作前请仔细阅读相关注意项。）
                </div>
            </div>
        </div>
        <div class="search-ctn" style="min-height: 30px; padding-top: 0; margin-top: -10px">
            <div class="search-ctn-right">
                <div class="search-name" style="margin-bottom: 5px">
                    <el-tooltip effect="dark" placement="bottom">
                        <div slot="content">当再次导入相同商品时，依据所选的更新条件更新商品信息，若没有选中更新条件则不会更新商品。</div>
                        <span>
                            <i class="el-icon-warning-outline"></i>
                        </span> </el-tooltip
                    >更新条件
                </div>
                <el-checkbox-group v-model="selectedLimit" size="small">
                    <el-checkbox v-for="item in limitList" :label="item" :key="item">{{ item }}</el-checkbox>
                </el-checkbox-group>
            </div>
        </div>
        <div class="table-ctn u-table-ctn">
            <u-table use-virtual :header-cell-style="{ background: '#F2F6FC' }" :border="true" :data="tableData" height="670" :row-height="34" style="width: 100%">
                <u-table-column label="汽配编码" show-overflow-tooltip min-width="200px" prop="APCode">
                    <template slot="header">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">编码是唯一值，导入数据以编码判断商品是否已存在</div>
                            <span>
                                <i class="el-icon-warning-outline"></i>
                            </span>
                        </el-tooltip>
                        汽配编码
                    </template>
                </u-table-column>
                <u-table-column label="汽配名称" show-overflow-tooltip min-width="150px" prop="APName"></u-table-column>
                <u-table-column label="互换码" show-overflow-tooltip min-width="200px" prop="GoodCode"> </u-table-column>
                <u-table-column label="适用车型" show-overflow-tooltip min-width="200px" prop="AutoSeries"> </u-table-column>
                <u-table-column label="汽配分类" show-overflow-tooltip width="100px" prop="Cate"> </u-table-column>
                <u-table-column label="品牌" show-overflow-tooltip min-width="100px" prop="Brand"> </u-table-column>
                <u-table-column label="单位" show-overflow-tooltip width="100px" prop="Unit"></u-table-column>
                <u-table-column label="库存数" show-overflow-tooltip width="100px" prop="Stock">
                    <template slot="header">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">选择‘累加库存’时，系统将根据导入所填写的库存数增减库存</div>
                            <span>
                                <i class="el-icon-warning-outline"></i>
                            </span>
                        </el-tooltip>
                        库存数
                    </template>
                </u-table-column>
                <u-table-column label="成本价" show-overflow-tooltip width="100px" prop="CostPrice"> </u-table-column>
                <u-table-column label="批发价" show-overflow-tooltip width="100px" prop="WholePrice"></u-table-column>
                <u-table-column label="零售价" show-overflow-tooltip width="100px" prop="RetailPrice"> </u-table-column>
                <u-table-column label="库存上限" show-overflow-tooltip width="100px" prop="UpperLimit"> </u-table-column>
                <u-table-column label="库存下限" show-overflow-tooltip width="100px" prop="LowerLimit"> </u-table-column>
                <u-table-column label="自定义属性" show-overflow-tooltip width="100px" prop="CustAttrs"> </u-table-column>
                <u-table-column label="配件尺寸" show-overflow-tooltip width="100px" prop="Size"> </u-table-column>
                <u-table-column label="仓库" show-overflow-tooltip min-width="80px" prop="Warehouse"></u-table-column>
                <u-table-column label="仓位" show-overflow-tooltip min-width="80px" prop="ShelfSpace">
                    <template slot="header">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                1.填写完整的仓库和仓位，配件商品会自动入库<br />
                                2.当再次导入相同商品时，选择‘累加库存’条件：会针对仓库仓位增加库存；若未填写仓库仓位将变更总库存数
                            </div>
                            <span>
                                <i class="el-icon-warning-outline"></i>
                            </span>
                        </el-tooltip>
                        仓位
                    </template>
                </u-table-column>
                <u-table-column label="产地" show-overflow-tooltip min-width="100px" prop="Origin"> </u-table-column>
                <u-table-column label="英文名称" show-overflow-tooltip min-width="150px" prop="ExAttribute4"> </u-table-column>
                <u-table-column label="英文车型" show-overflow-tooltip min-width="150px" v-if="isShowAutoSeriseEng" prop="ExAttribute6"> </u-table-column>
                <u-table-column label="绩效属性" show-overflow-tooltip min-width="100px" v-if="isShowPerf" prop="PerfSet"> </u-table-column>
                <u-table-column label="合作项目" show-overflow-tooltip min-width="100px" v-if="isShowProject" prop="Project"> </u-table-column>
            </u-table>
        </div>
        <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
    </div>
</template>
<script>
import Vue from 'vue';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            isCheckCode: true,
            pageTitle: '导入Excel',
            loading: false,
            saveLoading: false,
            tableData: [],
            APCodeList: [], //汽配编码集合，不重复的
            userId: userMsg.EmployeeId,
            entpId: userMsg.EntpId,
            url: '/api/UploadFile/UploadInventoryDataExcel',
            headerObj: {
                'access-key': userMsg.Token,
                reqApp: 'yqgPC'
            },
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            selectedLimit: [],
            limitList: [
                '累加库存',
                '更新汽配名称',
                '更新互换码',
                '更新车型',
                '更新品牌',
                '更新成本价',
                '更新零售价',
                '更新批发价',
                '更新汽配分类',
                '更新产地',
                '更新库存上限',
                '更新库存下限',
                '更新自定义属性',
                '更新配件尺寸',
                '更新单位',
                '更新英文名称'
            ],
            addCount: 0, //新增商品数
            editCount: 0, //编辑商品数
            jumpCount: 0, //跳过商品数
            isShowPerf: false,
            isShowProject: false,
            isShowAutoSeriseEng:false,
            recordId: ''
        };
    },
    mounted() {
        let that = this;
        this.getConfigByCodes().then(() => {
            if (!that.isCheckCode) {
                that.getUniqueSetData();
            }
            if (that.isShowPerf) {
                that.limitList.push('更新绩效属性');
            }
            if (that.isShowProject) {
                that.limitList.push('更新合作项目');
            }
            if (that.isShowAutoSeriseEng) {
                that.limitList.push('更新英文车型');
            }
            
        });
    },
    methods: {
        downFile() {
            let a = document.createElement('a');
            a.href = `/download/库存商品上传模板.xlsx`; // 这里的请求方式为get，如果需要认证，接口上需要带上token
            a.target = '_blank';
            a.click();
        },
        uploadSuccess(res) {
            if (res.errcode == 0) {
                this.tableData = res.data;
                if (res.data && res.data.length > 0) {
                    let arr = [0, 1, 2, 3, 4];
                    res.data.forEach((val, idx) => (arr[idx] = val.APCode));
                    this.APCodeList = Array.from(new Set(arr));
                }
            } else {
                this.$util.errorMsg(res.errmsg);
            }
            this.loading = false;
        },
        uploadErr(error) {
            this.loading = false;
            const result = JSON.parse(error.message);
            this.$util.errorMsg(result.message);
        },
        beforeUpload(file) {
            this.loading = true;
            this.tableData = [];
            this.APCodeList = [];
            this.addCount = 0;
            this.editCount = 0;
            this.jumpCount = 0;
        },
        handleExport() {
            if (!this.tableData || this.tableData.length == 0) {
                this.$util.warningMsg('请选择文件');
                return;
            }

            if (this.selectedLimit.includes('累加库存') && this.selectedLimit.includes('更新库存')) {
                this.$util.warningMsg('累加库存、更新库存只能选其一');
                return;
            }
            let that = this;
            that.saveLoading = true;

            if (that.saveCount == 0) that.uploadStartRecords('上传商品总数：' + this.tableData.length);

            let apList = [];
            let start = that.saveCount;
            let newtableData = that.tableData.slice(start, that.tableData.length);

            for (let i = 0; i < that.APCodeList.length; i++) {
                let code = that.APCodeList[i];
                let result = newtableData.filter(item => item.APCode == code);
                apList = apList.concat(result);
                if (apList.length >= 100 || apList.length + that.saveCount >= that.tableData.length) break;
            }

            let updateField = that.selectedLimit.join(',');
            that.$util
                .axiosPost({
                    url: '/api/EntpGoods/ImportEnterprisePart',
                    data: {
                        UpdateField: updateField,
                        AutopartList: apList
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.saveCount += apList.length;
                        let num = parseFloat(that.saveCount);
                        let total = parseFloat(that.tableData.length);
                        that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                        that.percentage = that.percentage > 100 ? 100 : that.percentage;
                        if (res.data) {
                            that.addCount += Number(res.data.addCount);
                            that.editCount += Number(res.data.editCount);
                            that.jumpCount += Number(res.data.jumpCount);
                        }

                        if (that.tableData.length <= that.saveCount) {
                            setTimeout(function () {
                                that.saveLoading = false;
                                let msg = `新增商品数${that.addCount}，编辑商品数${that.editCount}，跳过商品数${that.jumpCount}`;
                                that.$alert(msg, '保存成功', { confirmButtonText: '确定' });
                                that.percentage = 0;
                                (that.currtPage = 1), (that.tableData = []);
                                // that.addCount = 0;
                                // that.editCount = 0;
                                // that.jumpCount = 0;
                                that.saveCount = 0;
                                that.APCodeList = [];
                                that.$store.commit('updateNeedRefresh', true);
                                that.addImportGoodsRecord();
                                that.uploadEndRecords(msg);
                            }, 1000);
                        } else {
                            that.currtPage++;
                            //删除已经保存的汽配编码
                            apList.forEach(function (item, i) {
                                var index = that.APCodeList.findIndex(val => val.APCode == item.APCode);
                                if (index > -1) {
                                    that.APCodeList.splice(index, 1);
                                }
                            });
                            that.handleExport();
                        }
                    } else {
                        let msg = `新增商品数${that.addCount}，编辑商品数${that.editCount}，跳过商品数${that.jumpCount}`;
                        that.$alert(msg, res.errmsg, { confirmButtonText: '确定' });

                        that.uploadEndRecords(msg);
                    }
                })
                .catch(err => {
                    that.saveLoading = false;
                    if (that.addCount > 0 || that.editCount) that.addImportGoodsRecord();
                    let msg = `新增商品数${that.addCount}，编辑商品数${that.editCount}，跳过商品数${that.jumpCount}`;
                    that.$alert(msg, err.message, { confirmButtonText: '确定' });

                    that.uploadEndRecords(msg);
                });
        },
        //完成导入后添加操作日志,并且删除商品分类，品牌，单位缓存
        addImportGoodsRecord() {
            let that = this;
            let msg = `新增商品数${that.addCount}，编辑商品数${that.editCount}，跳过商品数${that.jumpCount}`;
            that.addCount = 0;
            that.editCount = 0;
            that.jumpCount = 0;
            that.$util.axiosPost({
                url: '/api/EntpGoods/AddImportGoodsRecord?msg=' + msg,
                hideLoading: true
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['xzqpbmdwyx', 'qyzdyspsx', 'hzxmxzset','zscxyw'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'xzqpbmdwyx': //是否检测编码重复
                                    this.isCheckCode = result;
                                    break;
                                case 'qyzdyspsx':
                                    this.isShowPerf = result; //绩效属性
                                    break;
                                case 'hzxmxzset':
                                    this.isShowProject = result;
                                    break;
                                case 'zscxyw':
                                    this.isShowAutoSeriseEng = result; //英文车型
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        getUniqueSetData() {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpUniqueSetDatas'
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        data.forEach(element => {
                            switch (element.AttrName) {
                                case '汽配名称':
                                    if (element.IsSpecial) {
                                        let index = that.limitList.findIndex(i => i == '更新汽配名称');
                                        that.limitList.splice(index, 1);
                                    }
                                    break;
                                case '汽配分类':
                                    if (element.IsSpecial) {
                                        let index = that.limitList.findIndex(i => i == '更新汽配分类');
                                        that.limitList.splice(index, 1);
                                    }
                                    break;
                                case '汽配品牌':
                                    if (element.IsSpecial) {
                                        let index = that.limitList.findIndex(i => i == '更新品牌');
                                        that.limitList.splice(index, 1);
                                    }
                                    break;
                                case '生产产地':
                                    if (element.IsSpecial) {
                                        let index = that.limitList.findIndex(i => i == '更新产地');
                                        that.limitList.splice(index, 1);
                                    }
                                    break;
                            }
                        });
                    }
                })
                .catch(() => {});
        },
        uploadStartRecords(desc) {
            let that = this;
            let params = { Type: 0, OpDesc: desc };
            that.$util.uploadStartRecords(params).then(res => {
                if (res.data) that.recordId = res.data;
            });
        },
        uploadEndRecords(desc) {
            let that = this;
            if (that.recordId) {
                let params = { RecordId: that.recordId, OpDesc: desc };
                that.$util.uploadEndRecords(params);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.search-btn {
    margin-left: 0;
    margin-right: 20px;
}
.codetag {
    font-size: 14px;
    border-style: none none none none;
    background-color: transparent;
}
.explain {
    flex-shrink: 0;
    margin: 0 10px 10px;
    height: 32px;
    line-height: 32px;
    color: #ef7a82;
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 99999;
}
.el-icon-warning-outline {
    color: orange;
    margin-right: 5px;
}
</style>
